const activeLabelStyles = {
  transform: "scale(0.85) translateY(-24px)",
};

export const inputStyles = {
  components: {
    Form: {
      variants: {
        floating: {
          container: {
            /* ---------------- Base Label ---------------- */

            label: {
              top: 0,
              right: 0,
              zIndex: 2,
              position: "absolute",
              pointerEvents: "none",
              transformOrigin: "right top",
              transition: "all .2s ease",

              backgroundColor: "input_label_bg",
              color: "input_label_color",

              mx: 3,
              px: 1,
              my: 3,
            },

            /* ---------------- Float ---------------- */

            _focusWithin: {
              label: {
                ...activeLabelStyles,
              },
            },

            "input:not(:placeholder-shown) + label, textarea:not(:placeholder-shown) ~ label, .chakra-select__wrapper + label, .chakra-input__group + label, &.has-value label":
              {
                ...activeLabelStyles,
              },

            /* ---------------- Disabled ---------------- */

            "input:disabled + label": {
              color: "var(--chakra-colors-input_disabled_label) !important",
              background: "var(--chakra-colors-input_label_bg) !important",
              opacity: 1,
            },

            "textarea:disabled ~ label": {
              color: "var(--chakra-colors-input_disabled_label) !important",
              background: "var(--chakra-colors-input_label_bg) !important",
              opacity: 1,
            },

            ".chakra-input__group input:disabled + label": {
              color: "var(--chakra-colors-input_disabled_label) !important",
              background: "var(--chakra-colors-input_label_bg) !important",
              opacity: 1,
            },
            /* ---------------- ReadOnly Input ---------------- */

            "input[readonly]": {
              backgroundColor: "var(--chakra-colors-input_readonly_bg) !important",
               color: "var(--chakra-colors-input_readonly_text) !important",
            },

            "input[aria-readonly='true']": {
              backgroundColor: "input_readonly_bg",
            },

            "textarea[readonly]": {
              backgroundColor: "input_readonly_bg",
            },

            "textarea[aria-readonly='true']": {
              backgroundColor: "input_readonly_bg",
            },

            /* ---------------- ReadOnly ---------------- */

            "input[readonly] + label": {
              color: "var(--chakra-colors-input_readonly_label) !important",
              background: "var(--chakra-colors-input_label_bg) !important",
              opacity: 1,
            },

            "input[aria-readonly='true'] + label": {
              color: "var(--chakra-colors-input_readonly_label) !important",
              background: "var(--chakra-colors-input_label_bg) !important",
              opacity: 1,
            },

            "textarea[readonly] ~ label": {
              color: "var(--chakra-colors-input_readonly_label) !important",
              background: "var(--chakra-colors-input_label_bg) !important",
              opacity: 1,
            },

            "textarea[aria-readonly='true'] ~ label": {
              color: "var(--chakra-colors-input_readonly_label) !important",
              background: "var(--chakra-colors-input_label_bg) !important",
              opacity: 1,
            },

            ".chakra-input__group input[readonly] + label": {
              color: "var(--chakra-colors-input_readonly_label) !important",
              background: "var(--chakra-colors-input_label_bg) !important",
              opacity: 1,
            },
          },
        },
      },
    },
  },
};
